import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useRef, useState } from 'react';
import styled, { useTheme } from 'styled-components';
import { initWistiaVideo, useIntersectionObserver, useWistiaVideoApi } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var KEYBOARD_KEYS = {
  SPACE: ' ',
  ENTER: 'Enter'
};
var WistiaImageWrapper = styled.div.withConfig({
  displayName: "Video__WistiaImageWrapper",
  componentId: "sc-1ngkx8n-0"
})(["position:relative;&:focus{", "}img{width:100%;max-width:100%;cursor:pointer;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.normalizeStyles(_objectSpread({}, theme.focus.outlines["default"]));
});

var Video = function Video(_ref2) {
  var thumbnail = _ref2.thumbnail,
      thumbnailAlt = _ref2.thumbnailAlt,
      rootRef = _ref2.rootRef,
      id = _ref2.id,
      containerId = _ref2.containerId,
      controls = _ref2.controls,
      togglePlay = _ref2.togglePlay,
      time = _ref2.time,
      options = _ref2.options;
  var theme = useTheme();

  var _useState = useState(!!thumbnail),
      isThumbnailVisible = _useState[0],
      setIsThumbnailVisible = _useState[1];

  var _useState2 = useState(controls),
      isControlsVisible = _useState2[0],
      setIsControlsVisible = _useState2[1];

  var _useState3 = useState(false),
      isInitialized = _useState3[0],
      setIsInitialized = _useState3[1];

  var videoId = id || containerId;
  var wistiaRef = useRef(null);
  var thumbnailRef = useRef(null);

  var _useState4 = useState(null),
      containerRef = _useState4[0],
      setContainerRef = _useState4[1];

  var container = useIntersectionObserver(containerRef, {
    freezeOnceVisible: true,
    rootMargin: '300px 0px 300px 0px'
  });
  var isVisible = !!(container !== null && container !== void 0 && container.isIntersecting);
  useEffect(function () {
    if (controls !== isControlsVisible) {
      setIsControlsVisible(controls);
      setIsInitialized(false);
    }
  }, [controls]);
  useEffect(function () {
    if (rootRef !== null && rootRef !== void 0 && rootRef.current) {
      setContainerRef(rootRef);
      return;
    }

    if (thumbnailRef !== null && thumbnailRef !== void 0 && thumbnailRef.current) {
      setContainerRef(thumbnailRef);
      return;
    }

    if (wistiaRef !== null && wistiaRef !== void 0 && wistiaRef.current) {
      setContainerRef(wistiaRef);
      return;
    }
  }, [rootRef, thumbnailRef, wistiaRef]);
  useEffect(function () {
    if (wistiaRef.current) {
      wistiaRef.current.style.height = '';

      if (!isControlsVisible && !thumbnail) {
        wistiaRef.current.style.pointerEvents = 'none';
      }
    }
  }, [wistiaRef, isControlsVisible, thumbnail]);
  var videoApi = useWistiaVideoApi({
    id: videoId || '',
    jsonp: true,
    options: options
  });
  useEffect(function () {
    if (isVisible && !isInitialized && !isThumbnailVisible) {
      prepareVideo();
    }
  }, [isVisible, isInitialized, isThumbnailVisible]);
  useEffect(function () {
    if (isVisible && !isThumbnailVisible && videoApi) {
      videoApi === null || videoApi === void 0 ? void 0 : videoApi.play();
    }

    return function () {
      videoApi === null || videoApi === void 0 ? void 0 : videoApi.remove();
    };
  }, [isVisible, isThumbnailVisible, videoApi]);
  useEffect(function () {
    if (!videoApi || isThumbnailVisible) {
      return;
    }

    if (typeof time !== 'undefined') {
      videoApi.time(time);
    }

    if (typeof togglePlay !== 'undefined') {
      togglePlay ? videoApi.play() : videoApi.pause();
    }
  }, [togglePlay, time, videoApi, isThumbnailVisible]);

  var prepareVideo = function prepareVideo() {
    var classes = [];

    if (!isControlsVisible) {
      classes.push('settingsControl=false', 'controlsVisibleOnLoad=false', 'volumeControl=false', 'playButton=false', 'playbar=false', 'smallPlayButton=false', 'qualityControl=false', 'fullscreenButton=false', 'playbackRateControl=false', 'muted=true');
    }

    setIsInitialized(true);

    if (wistiaRef.current) {
      initWistiaVideo({
        wrapper: wistiaRef.current,
        embedId: containerId,
        autoPlay: true,
        classes: classes,
        videoId: videoId
      });
    }
  };

  var handleClickThumbnail = function handleClickThumbnail() {
    // Prevent content from shifting while thumbnail disappears and video appears
    if (wistiaRef.current) {
      var _thumbnailRef$current;

      wistiaRef.current.style.height = "".concat((_thumbnailRef$current = thumbnailRef.current) === null || _thumbnailRef$current === void 0 ? void 0 : _thumbnailRef$current.offsetHeight, "px");
    }

    if (isThumbnailVisible) {
      prepareVideo();
    }

    setIsThumbnailVisible(false);
  };

  var handleKeyPress = function handleKeyPress(event) {
    if (event.key == KEYBOARD_KEYS.ENTER || event.key == KEYBOARD_KEYS.SPACE) {
      event.preventDefault();
      handleClickThumbnail();
    }
  };

  var getThumbnail = function getThumbnail() {
    return /*#__PURE__*/_jsx(WistiaImageWrapper, {
      ref: thumbnailRef,
      tabIndex: 0,
      role: "button",
      onClick: handleClickThumbnail,
      onKeyPress: handleKeyPress,
      children: /*#__PURE__*/_jsxs("picture", {
        children: [/*#__PURE__*/_jsx("source", {
          srcSet: "https://embed-fastly.wistia.com/deliveries/".concat(thumbnail, ".webp?image_play_button_size=2x&image_play_button=1&image_play_button_color=050038e0&image_resize=480"),
          type: "image/webp",
          media: theme.mediaQueries.v2Mobile
        }), /*#__PURE__*/_jsx("source", {
          srcSet: "https://embed-fastly.wistia.com/deliveries/".concat(thumbnail, ".jpg?image_play_button_size=2x&image_play_button=1&image_play_button_color=050038e0&image_resize=480"),
          type: "image/jpeg",
          media: theme.mediaQueries.v2Mobile
        }), /*#__PURE__*/_jsx("source", {
          srcSet: "https://embed-fastly.wistia.com/deliveries/".concat(thumbnail, ".webp?image_play_button_size=2x&image_play_button=1&image_play_button_color=050038e0"),
          type: "image/webp"
        }), /*#__PURE__*/_jsx("source", {
          srcSet: "https://embed-fastly.wistia.com/deliveries/".concat(thumbnail, ".jpg?image_play_button_size=2x&image_play_button=1&image_play_button_color=050038e0"),
          type: "image/jpeg"
        }), /*#__PURE__*/_jsx("img", {
          src: "https://embed-fastly.wistia.com/deliveries/".concat(thumbnail, ".jpg?image_play_button_size=2x&image_play_button=1&image_play_button_color=050038e0"),
          alt: thumbnailAlt
        })]
      })
    });
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isThumbnailVisible && getThumbnail(), /*#__PURE__*/_jsx("div", {
      ref: wistiaRef,
      "data-testid": "wistia-element-ref"
    }, JSON.stringify({
      controls: controls
    }))]
  });
};

export default Video;